const Footer = function ({ children }) {
  return (
    <footer className="footer fixed-bottom">{children}</footer>
  );
};

export default Footer;
